import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const FILES_ENDPOINTS = {
  secureFilename: `${BASE_URL}api/files/secure-filename/`,
  upload: `${BASE_URL}api/files/upload/`,
  download: `${BASE_URL}api/files/download/`,
  delete: `${BASE_URL}api/files/delete/`,
  list: `${BASE_URL}api/files/list/`,
  allowedExtensions: `${BASE_URL}api/files/allowed-extensions/`,
  availableFileTypes: `${BASE_URL}api/files/available_file_types/`,
};

class Files {
  async removeFile(query) {
    const { data } = await request({
      url: FILES_ENDPOINTS.delete,
      method: "DELETE",
      query,
    });
    return data;
  }

  async fetchAvailableFileTypes() {
    const { data } = await request({
      url: FILES_ENDPOINTS.availableFileTypes,
    });
    return data;
  }

  async fetchFiles(query) {
    let req = {
      url: FILES_ENDPOINTS.list,
      query: query || {},
    };

    const { data } = await request(req);
    return data;
  }
  async getAllowedExtensions(fileId){
    const { data } = await request({
      url: FILES_ENDPOINTS.allowedExtensions,
      query: {file_id: fileId}
    });
    return data;
  }

  async secureFilename(name){
    const { data } = await request({
      url: FILES_ENDPOINTS.secureFilename,
      query: {filename: name}
    });
    return data;
  }
}

export const FilesService = new Files();
